/* eslint-disable import/no-unused-modules */
import LeavingWordpress from 'components/StartBlog/LeavingWordpress';
import withApollo from '../lib/withApollo';

// Origin-story lander of the blogger-intent SEO cluster (docs/seo-plan.md §3).
const LeavingWordpressPage = () => <LeavingWordpress />;

export default withApollo(LeavingWordpressPage);
